import { z } from 'zod';

export const FooterSlotDTOTypes = {
    Reinsurance: z.literal('FOOTER_REINSURANCE'),
    Columns: z.literal('FOOTER_COLUMNS'),
    Compliance: z.literal('FOOTER_COMPLIANCE'),
    Social: z.literal('FOOTER_SOCIAL'),
};
